import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import Textarea from '../../../../components/forms/Textarea'
import Select from '../../../../components/forms/Select'
import GenericReferencialDto from '../../../dto/GenericReferencialDto'
import VariousMaterielDto from '../dto/VariousMaterielDto'
import { getDefaultValuesChoiceModal, getMatTypes } from '../../../../utils/MaterielUtils'
import NumberField from '../../../../components/forms/NumberField'

const VariousMaterielEquipmentPanel = ({
    active = false,
    disabled = true,
    variousMateriel = {},
    variousMaterielTypes = [],
    onChange = () => { },
}) => (
    <Grid size={12} sx={{ marginBottom: 1 }}>
        <Grid container spacing={1} sx={{ paddingTop: '3px' }}>
            <Grid size={4}>
                <Select
                    options={getMatTypes(variousMaterielTypes, variousMateriel.materielType)}
                    label={i18n.type}
                    onChange={value => {
                        onChange({ materielType: value })
                        getDefaultValuesChoiceModal(variousMaterielTypes.find(c => c.materielType == value), onChange)
                    }}
                    value={variousMateriel.materielType}
                    nullLabel='&nbsp;'
                    active={active}
                    disabled={disabled}
                />
            </Grid>
            <Grid size={4}>
                <NumberField
                    title={i18n.supplyTime}
                    value={variousMateriel.supplyTime}
                    onChange={value => onChange({ supplyTime: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
        <Grid container sx={{ paddingTop: '8px' }}>
            <Grid size={12}>
                <Textarea
                    title={i18n.comment}
                    value={variousMateriel.comment}
                    onChange={value => onChange({ comment: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
    </Grid>
)

VariousMaterielEquipmentPanel.propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onChange: PropTypes.func,
    variousMateriel: PropTypes.instanceOf(VariousMaterielDto),
    variousMaterielTypes: PropTypes.instanceOf(GenericReferencialDto),
}

const mapStateToProps = store => ({
    variousMaterielTypes: store.VariousMaterielReducer.variousMaterielTypes,
})

export default connect(mapStateToProps)(VariousMaterielEquipmentPanel)
